<template>
    <v-container v-if="this.zamawiajacy && this.rodzajWypowiedzenia" class="page">
  <table>
    <thead>
  <tr>
   <td colspan="2">
      <div class="left-container">
        <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
      </div>
    </td>
  </tr>
    <tr>
    <td style="text-align: right;">
      <div class="cointainer-right">
        <p align="right" style="margin-bottom: 10px; font-size: 14px;">
        Tutore Poland Sp. z o.o.<br>
        ul. Piotrkowska 157A, 90-440 Łódź<br>
        NIP: 7272812193
        </p>
        <p align="right" style="margin-bottom: 10px; font-size: 14px;">
          Łódź, dnia {{ aktualnaData() }} r.
        </p>
      </div>
    </td>
  </tr>
    </thead>
  <tbody>
  <tr>
  <td class="left-container" style="width:50%;">
<p align="center" style="margin-top:100px;">
<strong>Rozwiązanie umowy zlecenie za wypowiedzeniem</strong>
</p>
<p></p>
Niniejszym rozwiązuje umowę zlecenie nr {{ shortNrUmowy() }}, pomiędzy Tutore Poland Sp. z o.o., z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440 Łódź, {{ zamawiajacy === 'Marcin Grzelak - Prezes Zarządu' ? 'reprezentowanym' : 'reprezentowaną' }} przez {{ zamawiajacy }}, {{ zamawiajacy === 'Marcin Grzelak - Prezes Zarządu' ? 'zwanym' : 'zwaną' }} dalej zleceniodawcą, a Panem/Panią {{ zleceniobiorca }}, zamieszkałym/łą w {{ adresZamieszkania }} identyfikującym/cą się nr Pesel: {{ pesel }} - zwanym/ą dalej zleceniobiorcą. Rozwiązanie umowy zlecenie następuje za {{ okresWypowiedzeniaOdmiana() }} okresem wypowiedzenia.
</td>
<td class="right-container" style="width:50%;">
<p align="center" style="margin-top:100px;">
<strong>Termination of the contract of mandate by notice</strong>
</p>
<p></p>
Hereby terminates the contract no. {{ shortNrUmowy() }}, between Tutore Poland Sp. z o.o., with its registered office in Lodz at ul. Wroblewskiego 157A, 90-440 Lodz, represented by Ewa Szcześniewska - Plenipotentiary, hereinafter referred to as the principal, and Mr/Mrs {{ zleceniobiorca }}, resident/in the {{ adresZamieszkania }}, identifying/pesel no.: {{ pesel }} - hereinafter referred to as/the Contractor. Termination of the order agreement takes place after the {{ okresWypowiedzeniaOdmiana() }} notice period.
</td>
</tr>
<div class="cointainer" style="margin-top: 30px;">
      <div class="cointainer-left">
          <span>{{ zleceniobiorca }}</span><br>
          <span>(Podpis Zleceniobiorcy/Contractor's Signature)</span>
      </div>
      <div class="cointainer-right">
          <span>{{ zamawiajacy }}</span><br>
          <p>(Podpis Zleceniodawcy/Principal's Signature)</p>
      </div>
  </div>
    
    </tbody></table>
    </v-container>
  </template>
  
  <script>
  export default {
    name: 'WypowiedzenieENG',
    props: {
    },
    data () {
      return {
        dataRozwiazania: '',
        nrUmowy: '',
        zamawiajacy: '',
        zleceniobiorca: '',
        adresZamieszkania: '',
        pesel: '',
        okresWypowiedzenia: '',
        rodzajWypowiedzenia: ''
      }
    },
    created () {
      Object.entries(this.$route.query).forEach(
        ([key, value]) => { this[key] = value }
      )
    },
    methods: {
      aktualnaData() {
        const today = new Date();
        let day = today.getDate();
        if((day+1) <= 10) {
          day = '0' + day
        }
        let month = today.getMonth()+1;
        if ((today.getMonth()+1) < 10) {
          month = '0' + month
        } 
        const todayDate = day+'-'+month+'-'+today.getFullYear()
        return todayDate
      },
      dataWypowiedzeniaUmowy () {
        if (this.dataRozwiazania === '' || this.dataRozwiazania === '30-12-1899') {
          return ''
        } else {
          return `${this.dataRozwiazania}`
        }
      },
      okresWypowiedzeniaOdmiana() {
        if(this.okresWypowiedzenia === '5 dni') {
          return '5 dniowym'
        } else {
          return `${this.okresWypowiedzenia}`
        }
      },
      shortNrUmowy () {
        let tab = []
        let shortPosition = ''
        tab = this.nrUmowy.split('/')
        switch(tab[3]) {
          case 'Nauczyciel':
            shortPosition = 'Naucz'
            break;
          case 'NauczycielAnimatorLektor':
            shortPosition = 'NauAnimLek'
            break;
          case 'Metodyk':
            shortPosition = 'Met'
            break
          case 'Twórca':
            shortPosition = 'Tworca'
            break
          case 'TwórcaMateriałów':
            shortPosition = 'TMat'
            break
          case 'TwórcaFabrykaMateriałów':
            shortPosition = 'TFabMat'
            break
          case 'TwórcaMateriałówNauczycielMetodyk':
            shortPosition = 'TMatNauMet'
            break
          case 'MetodykTwórcaNauczyciel':
            shortPosition = 'MetTworcaNau'
            break
          case 'TworzenieProgramuNauczania':
            shortPosition = 'TPNau'
            break
          case 'AsystentOrganizacyjny':
            shortPosition = 'AOrg'
            break
          case 'MłodszyAsystentOrganizacyjny':
            shortPosition = 'MAOrg'
            break
          case 'TworzenieMap':
            shortPosition = 'TMapMC'
            break
          case 'TworcaFabrykaMaterialow':
            shortPosition = 'TFabMat'
            break
            case 'KonsultantTurystyka':
            shortPosition = 'TUR'
            break
            case 'KonsultantCC':
            shortPosition = 'CC'
            break
            case 'KonsultantInfolinia':
            shortPosition = 'INF'
            break
            case 'GrupaWsparciaTechnicznego':
            shortPosition = 'GWT'
            break
          default:
            shortPosition = tab[3]
        }
        const shortUmowa = `${tab[0]}/${tab[1]}/${tab[2]}/${shortPosition}`
        return shortUmowa
      },
    },
    mounted () {
      if (this.zamawiajacy) {
        this.$nextTick(() => {
          window.setTimeout(() => window.print(), 300)
        })
      }
    }
  }
  </script>
  
  <style scoped>
  .left-container {
   padding: 10px; 
   text-align: left;
   }
   .right-container {
   text-align: left;
   }   
  .page {
    size: 210mm 297mm;
    background-size: 100% 100%;
    line-height: 1.4;
    text-align: justify;
    margin-top: 2px;
    padding-top: 0px;
  }
  table, th, td {
    border: 1px;
    border-collapse: collapse;
  }
  .cointainer {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .cointainer-left {
    text-align: left;
    position: absolute;
    left: 0;
    margin-left: 50px;
  }
  .cointainer-right {
    text-align: right;
    position: absolute;
    right: 0;
    margin-right: 50px;
  }
  thead {
    display: table-header-group;
  }
  .table-border {
    border: 1px solid black;
    border-collapse: collapse;
    padding: 5px;
  }
  .cell-in-first-table {
    margin-top: 2px;
    margin-bottom: 2px;
    margin-left: 10px;
    margin-right: 10px;
  }
  ul.dashed {
    list-style-type: "- ";
    margin: 0;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/WypowiedzenieENG.vue